( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'triple-collage-left-right', COMPONENT );
} )( app );
